import { ReactElement } from 'react';

import { IconsPropsI } from './interfaces';

const CheckIcon = ({ width = 16, height = 12, fill = '#25A73A' }: IconsPropsI): ReactElement => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.50011 8.47485L1.60845 5.58319C1.28345 5.25819 0.758447 5.25819 0.433447 5.58319C0.108447 5.90819 0.108447 6.43319 0.433447 6.75819L3.91678 10.2415C4.24178 10.5665 4.76678 10.5665 5.09178 10.2415L13.9084 1.42485C14.2334 1.09985 14.2334 0.574853 13.9084 0.249854C13.5834 -0.0751465 13.0584 -0.0751465 12.7334 0.249854L4.50011 8.47485Z"
        fill={fill}
      />
    </svg>
  );
};

export default CheckIcon;
